"use client";

import styled, { css } from "styled-components";
import { sans as zoram, fontSize32, fontSize42, lineHeightTight, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority1 = css(["margin:0;font-family:", ";font-style:normal;font-weight:", ";font-size:", ";line-height:", ";letter-spacing:-0.03125rem;", ";"], zoram, fontWeightBold, fontSize32, lineHeightTight, props => props.$small ? "" : mediaBreak600w`font-size: ${fontSize42};`);
const H1Styled = styled.h1.withConfig({
  componentId: "sc-1tfwysu-0"
})(["", ";"], internalUseOnlyPriority1);

/**
 * The first level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h1` but be an `h2` (or other heading) if needed.
 * @param {object} props - The component props
 * @param {boolean} [props.small] - Whether smaller styles should be applied
 * @param {React.ReactNode} props.children - The content inside the heading
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., `"div"`) or React component to render
 * @returns {React.ReactNode} The H1 component
 */
const H1 = ({
  small,
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H1Styled, {
  $small: small,
  as: renderAs,
  ...props,
  children: children
});
H1.displayName = "H1";
export default H1;